<agpr-take-over-panel
    [id]="id"
    header="Reports.chartSetupDialog.heading"
    [overlayContainer]="overlayContainer"
    [animationTrigger]="animationTrigger"
    [hideSlideOverlay]="hideSlideOverlay"
    (visibleChange)="close($event)"
    [width]="80"
    [minPanelWidth]="1000"
    [maxPanelWidth]="1366"
    [responsiveWidth]="true"
>
    <div class="agpr-chartSetupDialog">
        <!-- Chart Selection -->
        @if(!editState) {
            <div class="agpr-chartSetupDialog-chartConfig">
                <!-- Chart Filters -->
                <div class="agpr-chartSetupDialog-chartConfig-column--left">
                    <div class="agpr-chartSetupDialog-toolbar">
                        <h2 class="agpr-chartSetupDialog-toolbar-heading">
                            {{ 'ChartSetupDialog.chartFilters' | localize }}
                        </h2>
                    </div>
                    @if (chartFilters?.length) {
                        <agpr-scroll-panel>
                            @for(filter of chartFilters; track filter; let i = $index) {
                                <agpr-filter-checkboxes
                                    #chartFilter
                                    [id]="`${id}_chartFilters_${i}`"
                                    class="agpr-chartSetupDialog-chartFilters-filter"
                                    [filter]="filter"
                                    (onChange)="filterChanged()"
                                ></agpr-filter-checkboxes>
                            }
                        </agpr-scroll-panel>
                    }
                </div>
                <!-- Available Charts -->
                <div class="agpr-chartSetupDialog-chartConfig-column--right">
                    <div class="agpr-chartSetupDialog-toolbar">
                        <h2 class="agpr-chartSetupDialog-toolbar-heading">
                            {{ 'Reports.chartSetupDialog.availableCharts' | localize }}
                        </h2>
                        <agpr-icon-dropdown
                            [id]="`${id}_iconDropdown`"
                            displayIcon="fa-regular fa-duotone fa-eye"
                            [options]="chartViewOptions"
                            [keepSelectedValue]="false"
                            inputTooltip="Reports.chartSetupDialog.chartViewSettings"
                            [(ngModel)]="selectedChartViewOption"
                            (ngModelChange)="selectChartViewOption()"
                            ariaLabel="Reports.chartSetupDialog.chartViewOptions"
                        ></agpr-icon-dropdown>
                        <agpr-slide-toggle
                            [id]="`${id}_slideToggle`"
                            [options]="viewModeOptions"
                            [ngModel]="selectedViewMode"
                            (ngModelChange)="viewModeChanged($event)"
                        ></agpr-slide-toggle>
                    </div>

                    <!-- Chart List -->
                    <div class="agpr-chartSetupDialog-chartsListContainer">
                        @if (charts?.length) {
                            <!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
                            <agpr-scroll-panel>
                                <div class="agpr-chartSetupDialog-chartsContainer">
                                    @if (showGalleryView) {
                                        <ul
                                            [id]="`${id}_chartTypes_grid`"
                                            class="agpr-chartSetupDialog-chartsContainer-grid"
                                            [attr.aria-label]="'Reports.chartSetupDialog.availableCharts' | localize"
                                            agprListKeyboardNavigation
                                            [list]="charts"
                                            listOrientation="horizontal"
                                        >
                                            @for (chart of charts; track chart; let i = $index) {
                                                <li
                                                    [id]="`${id}_chartTypes_grid_${i}`"
                                                    class="agpr-chartSetupDialog-chartsContainer-chartCard"
                                                    [ngClass]="{'agpr-chartSetupDialog-chartsContainer-chartCard--selected': selectedChartType && selectedChartType.key === chart.blockType.key}"
                                                    (keydown)="selectChart(chart.blockType, $event)"
                                                    (click)="selectChart(chart.blockType)"
                                                >
                                                    <div class="agpr-chartSetupDialog-chartsContainer-chartCard-header">
                                                        <span class="agpr-chartSetupDialog-chartsContainer-chartCard-label">
                                                            {{ chart.blockType.label | localize }}
                                                        </span>
                                                    </div>
                                                    @if (showDescription) {
                                                        <div class="agpr-chartSetupDialog-chartsContainer-chartCard-description">
                                                            {{ 'Reports.chart.toolTip.' + chart.blockType.key | localize}}
                                                        </div>
                                                    }
                                                    <div class="agpr-chartSetupDialog-chartsContainer-chartCard-footer">
                                                        @for(chartType of chart.chartTypes; track chartType.key) {
                                                            <span
                                                                role="img"
                                                                class="agpr-chartSetupDialog-chartsContainer-chartCard-icon"
                                                                [class]="chartType.icon"
                                                                [agprTooltip]="chartType.tooltip"
                                                                tooltipPosition="top"
                                                            ></span>
                                                        }
                                                    </div>
                                                </li>
                                            }
                                        </ul>
                                    } @else {
                                        <ul
                                            [id]="`${id}_chartTypes_list`"
                                            class="agpr-chartSetupDialog-chartsContainer-list"
                                            [attr.aria-label]="'Reports.chartSetupDialog.availableCharts' | localize"
                                            agprListKeyboardNavigation
                                            [list]="charts"
                                        >
                                            @for (chart of charts; track chart; let i = $index) {
                                                <li
                                                    [id]="`${id}_chartTypes_list_${i}`"
                                                    class="agpr-chartSetupDialog-chartsContainer-chartCard"
                                                    [ngClass]="{'agpr-chartSetupDialog-chartsContainer-chartCard--selected': selectedChartType && selectedChartType.key === chart.blockType.key}"
                                                    (keydown)="selectChart(chart.blockType, $event)"
                                                    (click)="selectChart(chart.blockType)"
                                                >
                                                    <div class="agpr-chartSetupDialog-chartsContainer-chartCard-header">
                                                        <span class="agpr-chartSetupDialog-chartsContainer-chartCard-label">
                                                            {{ chart.blockType.label | localize }}
                                                        </span>
                                                        @for(chartType of chart.chartTypes; track chartType.key) {
                                                            <span
                                                                role="img"
                                                                class="agpr-chartSetupDialog-chartsContainer-chartCard-icon"
                                                                [class]="chartType.icon"
                                                                [agprTooltip]="chartType.tooltip"
                                                                tooltipPosition="top"
                                                            ></span>
                                                        }
                                                    </div>
                                                    @if (showDescription) {
                                                        <div class="agpr-chartSetupDialog-chartsContainer-chartCard-description">
                                                            {{ 'Reports.chart.toolTip.' + chart.blockType.key | localize}}
                                                        </div>
                                                    }
                                                </li>
                                            }
                                        </ul>
                                    }
                                </div>
                            </agpr-scroll-panel>
                            <!-- eslint-enable @angular-eslint/template/interactive-supports-focus -->
                        } @else {
                            <agpr-message [severity]="messageSeverityEnum.noContent">
                                {{ 'ChartSetupDialog.noChartsMatch' | localize }}
                            </agpr-message>
                        }
                    </div>
                </div>
            </div>
        }

        <!-- Chart config page -->
        <div
            class="agpr-chartSetupDialog-chartConfig"
            *ngIf="editState"
        >
            <div class='agpr-chartSetupDialog-chartConfig-column--left'>
                <h2 id="chartSetupDialog_customize_heading" class="agpr-chartSetupDialog-chartConfig-column-heading">
                    {{ 'ChartSetupDialog.customize' | localize }}
                </h2>
                <agpr-scroll-panel #scrollpanel>
                    <div #settings
                        class='agpr-chartSetupDialog-chartConfig-configContents'
                        role="region"
                        aria-labelledby="chartSetupDialog_customize_heading"
                    >
                        <h3 class="agpr-chartSetupDialog-chartConfig-column-subHeading">
                            {{ 'Reports.chartSetupDialog.chartSetup' | localize }}
                        </h3>
                        <agpr-block-form #blockForm></agpr-block-form>
                    </div>
                </agpr-scroll-panel>
            </div>
            <div class='agpr-chartSetupDialog-chartConfig-column--right'>
                <h2 id="chartSetupDialog_preview_heading" class="agpr-chartSetupDialog-chartConfig-column-heading">
                    {{ 'Reports.chartSetupDialog.preview' | localize }}
                </h2>
                <agpr-scroll-panel>
                    <div class='agpr-chartSetupDialog-chartConfig-previewContents' role="region" aria-labelledby="chartSetupDialog_preview_heading">
                        <div [ngStyle]="{'width': blockWidth + 'px', 'height': blockHeight + 'px'}">
                            <agpr-block-wrapper
                                *ngIf="blockClone && blockClone.type && blockClone.displayElement"
                                [preview]="true"
                                [hideTooltip]="hidePreviewChartTooltip"
                                [block]="blockClone"
                            ></agpr-block-wrapper>
                            <div
                                *ngIf="!blockClone || !blockClone.type"
                                class='agpr-chartSetupDialog-chartConfig-noChartSelected'
                            >
                                <span class='fa-regular fa-duotone fa-chart-line agpr-chartSetupDialog-chartConfig-noChartSelectedIcon'></span>
                                {{ 'Reports.chartSetupDialog.noChartSelected' | localize }}
                            </div>
                        </div>
                    </div>
                </agpr-scroll-panel>
            </div>
        </div>
    </div>

    <ng-template #takeOverFooterLeft>
        <agpr-button
            [id]="`${id}_cancel`"
            label="Core.button.cancel"
            [style]="buttonTypes.secondary"
            (click)="hideSlideOverlay = true"
        ></agpr-button>
        @if (editState) {
            <agpr-button
                [id]="`${id}_changeChartType`"
                label="ChartSetupDialog.changeChartTypeButton"
                [style]="buttonTypes.secondary"
                (click)="openChartSettings(false)"
            ></agpr-button>
        }
    </ng-template>
    <ng-template #takeOverFooterRight>
        @if (!editState) {
            <agpr-button
                [id]="`${id}_nextStep`"
                [disabled]="!selectedChartType"
                label="Reports.nextStep"
                [style]="buttonTypes.primary"
                (click)="openChartSettings(true)"
            ></agpr-button>
        }
        @if (editState && isAdding) {
            <agpr-button
                [id]="`${id}_addChart`"
                (click)="addChart()"
                label="ChartSetupDialog.addChart"
                [style]="buttonTypes.primary"
                [disabled]="!chartIsValid"
            ></agpr-button>
        }
        @if (editState && !isAdding) {
            <agpr-button
                [id]="`${id}_updateChart`"
                (click)="updateChart()"
                label="Reports.button.saveChart"
                [style]="buttonTypes.primary"
                [disabled]="!chartIsValid"
            ></agpr-button>
        }
    </ng-template>
</agpr-take-over-panel>
